import type { LedgerRef } from '@nutrimatic/sdk'

import { ChainId } from '@/sdk'

/**
 * Default Telemetry host for local/dev.
 * Prod DNS `telemetry.nutrimatic.xyz` is not serving yet; Lab and live data use test.
 * Override with `VITE_NUTRIMATIC_API_BASE_URL`.
 *
 * Browser calls go direct to Telemetry (public CORS on `/nutrimatic/v1` + `/ready`).
 */
export const NUTRIMATIC_DEFAULT_API_BASE_URL = 'https://telemetry-test.nutrimatic.xyz'

export const NUTRIMATIC_INFINITE_MAINNET_LEDGER: LedgerRef = {
  id: 'evm:421018',
  kind: 'evm',
  chainId: ChainId.INFINITE_MAINNET,
  alias: 'infinite-mainnet',
}

export function getNutrimaticApiBaseUrl(): string {
  const raw = import.meta.env.VITE_NUTRIMATIC_API_BASE_URL?.trim()
  const base = raw || NUTRIMATIC_DEFAULT_API_BASE_URL
  return base.replace(/\/+$/, '')
}

export function isNutrimaticConfigured(): boolean {
  return Boolean(getNutrimaticApiBaseUrl())
}

/** Ledger Nutrimatic for the active Don't Panic chain — only Infinite Mainnet today. */
export function getNutrimaticLedgerForChain(chainId: number): LedgerRef | null {
  if (chainId === ChainId.INFINITE_MAINNET) {
    return NUTRIMATIC_INFINITE_MAINNET_LEDGER
  }
  return null
}
